
import useGetQuery from "./helper/useGetQuery"
  
const API = {
  ADD: `home/overview`,
  GET_ALL: `home/overview`,
  DELETE: `home/overview`,
  UPDATE: `home/overview`,

};
const KEY = ["home","order","users","categories"]


export const useGetHome = (params?:any) => useGetQuery(KEY, API.GET_ALL,params);